/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import LandingPageLayout from '../../components/layouts/LandingPageLayout';
import Jens from '/public/static/jens.png';
import Image from 'next/image';
export const meta = {
  author: 'Jens Arre Seip'
};
const MDXLayout = ({children}) => _jsx(LandingPageLayout, {
  mdx: true,
  meta: meta,
  title: "Curipod, GDPR, cloud vendors and Schrems II",
  subTitle: "How Curipod is handling the implications of Schrems II",
  children: children
});
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      p: "p",
      h3: "h3",
      strong: "strong",
      a: "a"
    }, props.components);
    return _jsxs(_Fragment, {
      children: [_jsx(Image, {
        src: Jens
      }), "\n", _jsx(_components.p, {
        children: "Dear teachers, students and school leaders"
      }), "\n", _jsx(_components.p, {
        children: "In the aftermath of the Schrems II verdict from the European Court, Curipod has received multiple questions from schools leaders, teachers and students regarding which measures Curipod has taken in light of the verdict. The most common questions are around Curipod's use of subcontractors from the U.S. I am publishing this to clarify what we are doing in Curipod to stay GDPR compliant in accordance with the Schrems II verdict."
      }), "\n", _jsx(_components.h3, {
        children: _jsx(_components.strong, {
          children: "What is new after Schrems II?"
        })
      }), "\n", _jsx(_components.p, {
        children: "In the Schrems II judgment, the European Court of Justice provides additional requirements for the transfer of personal data to countries outside the EU/EEA (third countries). This means that it is no longer sufficient to merely use a valid transfer basis such as the European Commission's standard provisions (EU SCC), binding corporate rules (BCR). If one wants to transfer or process data in the U.S. or any other third country, one must establish “additional measures”. It is still unclear what this means in practise."
      }), "\n", _jsx(_components.h3, {
        children: _jsx(_components.strong, {
          children: "How Curipod use US cloud vendors"
        })
      }), "\n", _jsx(_components.p, {
        children: "All of Curipod's cloud hosting providers (Azure, Google) and third party services (Mixpanel, Mailjet, Elasticsearch) host data on data centres within the EU/EEA. This means that all customer data, including backups of customer data, in Curipod, are processed within the EU/EEA only."
      }), "\n", _jsx(_components.p, {
        children: "The cloud hosting provider’s personnel are not granted access to customer data. Curipod does not transfer customer data outside the EU/EEA, nor does Curipod instruct our cloud hosting providers or third party services to do so."
      }), "\n", _jsx(_components.h3, {
        children: _jsx(_components.strong, {
          children: "What now?"
        })
      }), "\n", _jsxs(_components.p, {
        children: ["We are paying close attention to all new information such as the ongoing investigating by the ", _jsx(_components.strong, {
          children: _jsx(_components.a, {
            href: "https://edps.europa.eu/press-publications/press-news/press-releases/2021/edps-opens-two-investigations-following-schrems_en",
            children: "EDPS of the European Union's use of Azure and AWS"
          })
        }), ", so that we can always stay compliant with the GDPR."]
      })]
    });
  }
}
export default MDXContent;
